var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.86 30.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#868787;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.18,9.36V7.25a7.25,7.25,0,0,0-14.5,0V9.36A4.74,4.74,0,0,0,0,14.09V25.38A4.74,4.74,0,0,0,4.74,30.1H19.13a4.72,4.72,0,0,0,4.73-4.72V14.09a4.74,4.74,0,0,0-4.68-4.73ZM6.69,7.25a5.25,5.25,0,0,1,10.49,0V9.36H6.69ZM21.86,25.38a2.68,2.68,0,0,1-2.68,2.67H4.74a2.68,2.68,0,0,1-2.68-2.67V14.09a2.68,2.68,0,0,1,2.68-2.68H19.13a2.67,2.67,0,0,1,2.67,2.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.93,15.05a2,2,0,0,0-1.34,3.49v4.53a1.34,1.34,0,0,0,2.68,0V18.54a2,2,0,0,0-1.34-3.49Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.846e771833bcccb583d6db06d259470d.svg";
export { ForwardRef as ReactComponent };